import React, { useEffect, useState } from "react";

function getCurrentTheme() {
  return document.documentElement.getAttribute("data-theme") || "light";
}

function EconoJournalLogo({ className = "logoECJ", forceLightLogo = false }) {
  const [theme, setTheme] = useState(getCurrentTheme);
  const logoSrc = forceLightLogo || theme === "dark" ? "/img/ECJ-light.svg" : "/img/ECJ-dark.svg";

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setTheme(getCurrentTheme());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <img
      className={className}
      src={logoSrc}
      alt="EconoJournal"
    />
  );
}

export default EconoJournalLogo;
